// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./virtual-assets.d.ts" />
import assets from 'virtual:@rhino-project/core/config/assets';

export default {
  ...assets
};
